import { Text } from '@oneaudi/unified-web-components';
import styled from 'styled-components';

export const Container = styled.span`
  display: flex;
`;

export const StyledText = styled(Text)`
  color: #eb0d3f;
  font-size: 12px;
  margin-left: 8px;
`;
